import { takeLatest, call, put, all } from 'redux-saga/effects';
import PageTemplate from './index.js';

function* fetchPageTemplates({ payload: { validFor, formatType } }) {
  const response = yield call(PageTemplate.Api.fetchPageTemplates, validFor, formatType);
  if (response.error) yield put(PageTemplate.Actions.fetchPageTemplatesFailure(response.error));
  else yield put(PageTemplate.Actions.fetchPageTemplatesSuccess(response));
}

export default function* pageTemplatesSagas() {
  yield all([takeLatest(PageTemplate.Actions.fetchPageTemplates.getType(), fetchPageTemplates)]);
}
